import React, { useState } from 'react';
import style from './News.module.css';
import useNews from '../../hooks/useNews';

const News = ({ stock }) => {
  const { news } = useNews(stock.id);

  return (
    <div className={style.news}>
      { news?.length > 0 &&
        news.map((article, index) => {
          return <Article article={article} key={index} />;
        })
      }
    </div>
  );
};

export default News;

const Article = ({ article }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`${isOpen && style.isOpen}`}>
      <button onClick={() => setIsOpen(!isOpen)} className={style.openArticleButton}>
        <img src={article.image} alt={article.headline} width="50" height="50" className={style.articleImage} />
        <div>
          <h4 className={style.articleTitle}>
            {article.headline}
          </h4>
          <p className={style.subtitle}>
            {formatDate(article.datetime)} - {article.source}
          </p>
        </div>
      </button>
      <div className={style.hiddenContent}>
        <p className={style.description}>
          {truncateString(article.summary, 380)}
        </p>
        <a href={article.url} className={style.externalLink} target="_blank" rel="noopener noreferrer">
          <img src="/react/phosphor/arrow-square-out.svg" alt="Open" width="14" height="14" />
          <span>Open {article.source}</span>
        </a>
      </div>
    </div>
  )
};

function formatDate(date) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString('en-US', options);
}

function truncateString(str, num) {
  if (str.length > num) {
    return str.slice(0, num) + "...";
  } else {
    return str;
  }
}